// website-data.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  Select,
  MenuItem,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";

import { Chart } from "react-google-charts";

import config from '../twh/config';

const BASE_URL = config.reactApi_baseUrl + '/react-api/data-insights/website-data';

// 🔥 Conversions
const api_conversions                 = BASE_URL + "/GA4-conversions.php";

// 🔥 Website
const api_3scoreCard                  = BASE_URL + "/GA4-3scorecards.php";
const api_sessionDefaultChannelGroup  = BASE_URL + "/GA4-sessionDefaultChannelGroup.php";
const api_totalUserDayOfWeek          = BASE_URL + "/GA4-totalUserDayOfWeek.php";
const api_userGender                  = BASE_URL + "/GA4-userGender.php";
const api_userAge                     = BASE_URL + "/GA4-userAge.php";
const api_deviceCategory              = BASE_URL + "/GA4-deviceCategory.php";

// 🔥 Reservations
const api_reservations                = BASE_URL + "/GA4-reservations.php";
const api_reservations_table          = BASE_URL + "/GA4-reservations-table.php";


export default function Conversions() {
  const [dateRange, setDateRange] = useState("1 Week");
  const [customMode, setCustomMode] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  




  /* API 1 */

  const [api1_purchase, setAPI1_Purchase] = useState({ views: 0, percentage: "N/A" });
  const [api1_viewMenu, setAPI1_ViewMenu] = useState({ views: 0, percentage: "N/A" });
  const [api1_formFilled, setAPI1_FormFilled] = useState({ views: 0, percentage: "N/A" });
  const [api1_widgetOpen, setAPI1_WidgetOpen] = useState({ views: 0, percentage: "N/A" });
  const [api1_clickContact, setAPI1_ClickContact] = useState({ views: 0, percentage: "N/A" });

  const [api1_loading, setAPI1_Loading] = useState(false);

  const fetchData_conversions = async (range) => {
    try {
      setAPI1_Loading(true);

      const res = await fetch(api_conversions, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();

      setAPI1_Purchase({
        views: json?.purchase?.views || 0,
        percentage: json?.purchase ? json.purchase.percentage + "%" : "N/A",
      });

      setAPI1_ViewMenu({
        views: json?.view_menu?.views || 0,
        percentage: json?.view_menu ? json.view_menu.percentage + "%" : "N/A",
      });

      setAPI1_FormFilled({
        views: json?.form_filled?.views || 0,
        percentage: json?.form_filled ? json.form_filled.percentage + "%" : "N/A",
      });

      setAPI1_WidgetOpen({
        views: json?.widget_open?.views || 0,
        percentage: json?.widget_open ? json.widget_open.percentage + "%" : "N/A",
      });

      setAPI1_ClickContact({
        views: json?.click_contact?.views || 0,
        percentage: json?.click_contact
          ? json.click_contact.percentage + "%"
          : "N/A",
      });

    } catch (err) {
      console.error(err);
    } finally {
      setAPI1_Loading(false);
    }
  };





  /* API 2 */
  const [api2_sessions, setAPI2_Sessions] = useState({ views: 0, percentage: "N/A" });
  const [api2_totalUsers, setAPI2_TotalUsers] = useState({ views: 0, percentage: "N/A" });
  const [api2_engagementRate, setAPI2_EngagementRate] = useState({ views: 0, percentage: "N/A" });

  const [api2_loading, setAPI2_Loading] = useState(false);

  const fetchData_3scoreCard = async (range) => {
    try {
      setAPI2_Loading(true);

      const res = await fetch(api_3scoreCard, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();

      setAPI2_Sessions({
        views: json?.sessions?.views || 0,
        percentage: json?.sessions ? json.sessions.percentage + "%" : "N/A",
      });
      setAPI2_TotalUsers({
        views: json?.totalUsers?.views || 0,
        percentage: json?.totalUsers ? json.totalUsers.percentage + "%" : "N/A",
      });
      setAPI2_EngagementRate({
        views: json?.engagementRate?.views || 0,
        percentage: json?.engagementRate ? json.engagementRate.percentage + "%" : "N/A",
      });

      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI2_Loading(false);
    }
  };




  /* API 3 */
  const [api3_channelGroup, setAPI3_ChannelGroup] = useState([["Channel", "Sessions"]]);
  
  const [api3_loading, setAPI3_Loading] = useState(false);
  
  const fetchData_sessionDefaultChannelGroup = async (range) => {
    try {
      setAPI3_Loading(true);

      const res = await fetch(api_sessionDefaultChannelGroup, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
     
      setAPI3_ChannelGroup(json);
      
      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI3_Loading(false);
    }
  };



  /* API 4 */
  const [api4_totalUserDayOfWeek, setAPI4_totalUserDayOfWeek] = useState([["Days", "Views"]]);
  
  const [api4_loading, setAPI4_Loading] = useState(false);

  const fetchData_totalUserDayOfWeek = async (range) => {
    try {
      setAPI4_Loading(true);

      const res = await fetch(api_totalUserDayOfWeek, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
      
      setAPI4_totalUserDayOfWeek(json);
      
      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI4_Loading(false);
    }
  };


  /* API 5 */
  const [api5_userGender, setAPI5_userGender] = useState([["Gender", "Users"]]);
  
  const [api5_loading, setAPI5_Loading] = useState(false);

  const fetchData_userGender = async (range) => {
    try {
      setAPI5_Loading(true);

      const res = await fetch(api_userGender, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
      json.reverse();
      setAPI5_userGender(json);
      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI5_Loading(false);
    }
  };




  /* API 6 */
  const [api6_userAge, setAPI6_userAge] = useState([["Ages", "Users"]]);
  
  const [api6_loading, setAPI6_Loading] = useState(false);

  const fetchData_userAge = async (range) => {
    try {
      setAPI6_Loading(true);

      const res = await fetch(api_userAge, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
      json.reverse();
      setAPI6_userAge(json);
      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI6_Loading(false);
    }
  };





  /* API 7 */
  const [api7_deviceCategory, setAPI7_deviceCategory] = useState([["Devices", "Users"]]);
  
  const [api7_loading, setAPI7_Loading] = useState(false);

  const fetchData_deviceCategory = async (range) => {
    try {
      setAPI7_Loading(true);

      const res = await fetch(api_deviceCategory, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
      //json.reverse();
      setAPI7_deviceCategory(json);
      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI7_Loading(false);
    }
  };



  /* API 8 */
 
  const [api8_direct, setAPI8_Direct] = useState({ views: 0, percentage: "N/A" });
  const [api8_organic_search, setAPI8_OrganicSearch] = useState({ views: 0, percentage: "N/A" });
  const [api8_paid_search, setAPI8_PaidSearch] = useState({ views: 0, percentage: "N/A" });
  const [api8_paid_social, setAPI8_PaidSocial] = useState({ views: 0, percentage: "N/A" });
  const [api8_organic_social, setAPI8_OrganicSocial] = useState({ views: 0, percentage: "N/A" });
  const [api8_referral, setAPI8_Referral] = useState({ views: 0, percentage: "N/A" });
  const [api8_cross_network, setAPI8_CrossNetwork] = useState({ views: 0, percentage: "N/A" });
  
  const [api8_loading, setAPI8_Loading] = useState(false);

  const fetchData_reservations = async (range) => {
    try {
      setAPI8_Loading(true);

      const res = await fetch(api_reservations, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
      //json.reverse();

      setAPI8_Direct({
        views: json["Direct"] ? json["Direct"] .views : 0,
        percentage: json["Direct"]  ? json["Direct"].percentage + "%" : "N/A",
      });

      setAPI8_OrganicSearch({
        views: json["Organic Search"] ? json["Organic Search"].views : 0,
        percentage: json["Organic Search"] ? json["Organic Search"].percentage + "%" : "N/A",
      });
     
      setAPI8_PaidSearch({
        views: json["Paid Search"] ? json["Paid Search"].views : 0,
        percentage: json["Paid Search"] ? json["Paid Search"].percentage + "%" : "N/A",
      });
     
      setAPI8_PaidSocial({
        views: json["Paid Social"] ? json["Paid Social"].views : 0,
        percentage: json["Paid Social"] ? json["Paid Social"].percentage + "%" : "N/A",
      });
      
      setAPI8_OrganicSocial({
        views: json["Organic Social"] ? json["Organic Social"].views : 0,
        percentage: json["Organic Social"] ? json["Organic Social"].percentage + "%" : "N/A",
      });
      
      setAPI8_Referral({
        views: json["Referral"] ? json["Referral"].views : 0,
        percentage: json["Referral"] ? json["Referral"].percentage + "%" : "N/A",
      });
      
      setAPI8_CrossNetwork({
        views: json["Cross-network"] ? json["Cross-network"].views : 0,
        percentage: json["Cross-network"] ? json["Cross-network"].percentage + "%" : "N/A",
      });
     
      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI8_Loading(false);
    }
  };





  /* API 9 */
 
  const [api9_reservations_table, setAPI9_ReservationsTable] = useState({});
  
  const [api9_loading, setAPI9_Loading] = useState(false);

  const fetchData_reservations_table = async (range) => {
    try {
      setAPI9_Loading(true);

      const res = await fetch(api_reservations_table, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          dateRange: range,
        }),
      });

      const json = await res.json();
      
      setAPI9_ReservationsTable(json);

      
      

    } catch (err) {
      console.error(err);
    } finally {
      setAPI9_Loading(false);
    }
  };

















  // dropdown change
  const handleChange = (value) => {
    setDateRange(value);

    if (value === "custom") {
      setCustomMode(true);
    } else {
      setCustomMode(false);
      fetchData_conversions(value);
      fetchData_3scoreCard(value);
      fetchData_sessionDefaultChannelGroup(value);
      fetchData_totalUserDayOfWeek(value);
      fetchData_userGender(value);
      fetchData_userAge(value);
      fetchData_deviceCategory(value);
      fetchData_reservations(value);
      fetchData_reservations_table(value);
    }
  };

  // custom submit
  const handleCustomSubmit = () => {
    if (!startDate || !endDate) return;
    fetchData_conversions(`${startDate}====${endDate}`);
    fetchData_3scoreCard(`${startDate}====${endDate}`);
    fetchData_sessionDefaultChannelGroup(`${startDate}====${endDate}`);
    fetchData_totalUserDayOfWeek(`${startDate}====${endDate}`);
    fetchData_userGender(`${startDate}====${endDate}`);
    fetchData_userAge(`${startDate}====${endDate}`);
    fetchData_deviceCategory(`${startDate}====${endDate}`);
    fetchData_reservations(`${startDate}====${endDate}`);
    fetchData_reservations_table(`${startDate}====${endDate}`);
  };

  useEffect(() => {
    fetchData_conversions(dateRange);
    fetchData_3scoreCard(dateRange);
    fetchData_sessionDefaultChannelGroup(dateRange);
    fetchData_totalUserDayOfWeek(dateRange);
    fetchData_userGender(dateRange);
    fetchData_userAge(dateRange);
    fetchData_deviceCategory(dateRange);
    fetchData_reservations(dateRange);
    fetchData_reservations_table(dateRange);
  }, []);

  return (
    <Box>
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h4" fontWeight={800} gutterBottom>
          WEBSITE DATA
        </Typography>
        <Select
          size="small"
          value={dateRange}
          onChange={(e) => handleChange(e.target.value)}
        >
          <MenuItem value="3 Days">3 Days</MenuItem>
          <MenuItem value="1 Week">1 Week</MenuItem>
          <MenuItem value="1 Month">1 Month</MenuItem>
          <MenuItem value="6 Months">6 Months</MenuItem>
          <MenuItem value="1 Year">1 Year</MenuItem>
          <MenuItem value="custom">Custom</MenuItem>
        </Select>
      </Box>

      {/* CUSTOM DATE */}
      {customMode && (
        <Box display="flex" gap={2} mb={3}>
          <TextField
            type="date"
            label="Start Date"
            size="small"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <TextField
            type="date"
            label="End Date"
            size="small"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <Button variant="contained" onClick={handleCustomSubmit}>
            Get
          </Button>
        </Box>
      )}

      <Typography variant="h6" fontWeight={800} gutterBottom>
        Conversions
      </Typography>

      <Grid container spacing={2} sx={{mb:2}}>
        <Grid item size={{md:6}}>
          <Card sx={{ px:3, py:2, textAlign: "center", minHeight: 205, position:'relative' }}>
            {api1_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api1_purchase.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>TOTAL RESERVERINGEN</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api1_purchase.percentage}</Typography>
          </Card>
        </Grid>
        <Grid item size={{md:6}}>
          <Grid container spacing={2} sx={{mb:2}}>
            <Grid item size={{md:6}}>
              <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
                {api1_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
                <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api1_viewMenu.views}</Typography>
                <Typography sx={{fontSize:'12px'}}>VIEW MENU</Typography>
                <Typography color="success.main" sx={{fontSize:'12px'}}>{api1_viewMenu.percentage}</Typography>
              </Card>
            </Grid>
            <Grid item size={{md:6}}>
              <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
                {api1_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
                <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api1_formFilled.views}</Typography>
                <Typography sx={{fontSize:'12px'}}>FORM FILLED</Typography>
                <Typography color="success.main" sx={{fontSize:'12px'}}>{api1_formFilled.percentage}</Typography>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item size={{md:6}}>
              <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
                {api1_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
                <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api1_widgetOpen.views}</Typography>
                <Typography sx={{fontSize:'12px'}}>WIDGET OPEN</Typography>
                <Typography color="success.main" sx={{fontSize:'12px'}}>{api1_widgetOpen.percentage}</Typography>
              </Card>
            </Grid>
            <Grid item size={{md:6}}>
              <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
                {api1_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
                <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api1_clickContact.views}</Typography>
                <Typography sx={{fontSize:'12px'}}>CLICK CONTACT</Typography>
                <Typography color="success.main" sx={{fontSize:'12px'}}>{api1_clickContact.percentage}</Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Typography variant="h6" fontWeight={800} gutterBottom>
        Website
      </Typography>

      <Grid container spacing={2}>
        <Grid item size={{md:8}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', height:'330px' }}>
            {api3_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography sx={{mb:2, fontSize:'12px'}}>CHANNEL GROUP</Typography>
            <Chart
              chartType="Bar"
              width="100%"
              height="100%"
              data={api3_channelGroup}
              options={{
                bars: "horizontal",
                legend: { position: "none" },
              }}
            />

          </Card>
        </Grid>
        <Grid item size={{md:4}}>
             <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', mb:2 }}>
                {api2_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
                <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api2_sessions.views}</Typography>
                <Typography sx={{fontSize:'12px'}}>SESSIONS</Typography>
                <Typography color="success.main" sx={{fontSize:'12px'}}>{api2_sessions.percentage}</Typography>
              </Card>
             <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', mb:2 }}>
                {api2_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
                <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api2_totalUsers.views}</Typography>
                <Typography sx={{fontSize:'12px'}}>TOTAL USERS</Typography>
                <Typography color="success.main" sx={{fontSize:'12px'}}>{api2_totalUsers.percentage}</Typography>
              </Card>
             <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', mb:2 }}>
                {api2_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
                <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api2_engagementRate.views}</Typography>
                <Typography sx={{fontSize:'12px'}}>ENGAGEMENT</Typography>
                <Typography color="success.main" sx={{fontSize:'12px'}}>{api2_engagementRate.percentage}</Typography>
              </Card>
        </Grid>
      </Grid>

                
      <Grid container spacing={2}>
        <Grid item size={{md:6}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', height:'250px' }}>
            {api4_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography sx={{mb:2, fontSize:'12px'}}>TOTAL USERS (Day of Week)</Typography>
            <Chart
              chartType="Bar"
              width="100%"
              height="100%"
              data={api4_totalUserDayOfWeek}
              options={{
                bars: "horizontal",
                legend: { position: "none" },
              }}
            />

          </Card>
        </Grid>
        <Grid item size={{md:6}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', height:'250px' }}>
            {api5_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography sx={{mb:2, fontSize:'12px'}}>TOTAL USERS (Gender)</Typography>
            <Chart
              chartType="PieChart"
              width="100%"
              height="100%"
              data={api5_userGender}
              options={{
                pieHole: 0.2,
                legend: { position: "right" },
                colors: ["#007BFF", "#15BF78"],
              }}
            />

          </Card>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item size={{md:6}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', height:'250px' }}>
            {api6_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography sx={{mb:2, fontSize:'12px'}}>TOTAL USERS (Age)</Typography>
            <Chart
              chartType="Bar"
              width="100%"
              height="100%"
              data={api6_userAge}
              options={{
                bars: "horizontal",
                legend: { position: "none" },
              }}
            />

          </Card>
        </Grid>
        <Grid item size={{md:6}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative', height:'250px' }}>
            {api7_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography sx={{mb:2, fontSize:'12px'}}>TOTAL USERS (Device)</Typography>
            {Object.entries(api7_deviceCategory).map(([device, item]) => (
              
                <Box mb={1} key={device}>
                  
                  {/* Top Row */}
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography fontSize="12px">{device}</Typography>
                    <Typography fontSize="12px">{item.views}</Typography>
                  </Box>

                    <Box
                      sx={{
                        height: 6,
                        width: "100%",
                        background: "#eee",
                        borderRadius: 5,
                      }}
                    >
                      <Box
                        sx={{
                          height: "100%",
                          width: `${item.percentage}%`,
                          background: "#1976d2",
                          borderRadius: 5,
                        }}
                      />
                    </Box>

                </Box>
              
            ))}
          </Card>
        </Grid>
      </Grid>


      <Typography variant="h6" fontWeight={800} gutterBottom>
        Performance per Channel
      </Typography>
      <Grid container spacing={2}>
        <Grid item size={{md:4}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
            {api8_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api8_direct.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>Direct</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api8_direct.percentage}</Typography>
          </Card>
        </Grid>
        <Grid item size={{md:4}} sx={{mb:2}}>
         <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
            {api8_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api8_organic_search.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>Organic Search</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api8_organic_search.percentage}</Typography>
          </Card>
        </Grid>
        <Grid item size={{md:4}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
            {api8_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api8_paid_search.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>Paid Search</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api8_paid_search.percentage}</Typography>
          </Card>
        </Grid>
      </Grid>


      <Grid container spacing={2}>
        <Grid item size={{md:3}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
            {api8_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api8_paid_social.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>Paid Social</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api8_paid_social.percentage}</Typography>
          </Card>
        </Grid>
        <Grid item size={{md:3}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
            {api8_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api8_organic_social.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>Organic Social</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api8_organic_social.percentage}</Typography>
          </Card>
        </Grid>
        <Grid item size={{md:3}} sx={{mb:2}}>
         <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
            {api8_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api8_referral.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>Referral</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api8_referral.percentage}</Typography>
          </Card>
        </Grid>
        <Grid item size={{md:3}} sx={{mb:2}}>
          <Card sx={{ px:3, py:2, textAlign: "center", position:'relative' }}>
            {api8_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}
            <Typography variant="h4" sx={{fontWeight:'bold', color:'#0718AB'}}>{api8_cross_network.views}</Typography>
            <Typography sx={{fontSize:'12px'}}>Cross Network</Typography>
            <Typography color="success.main" sx={{fontSize:'12px'}}>{api8_cross_network.percentage}</Typography>
          </Card>
        </Grid>
      </Grid>


        <Grid container spacing={2}>
        <Grid item size={{ md: 12 }} sx={{ mb: 2 }}>
          <Card sx={{ px: 3, py: 2, position: "relative" }}>
            {api9_loading && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}

            <Typography sx={{mb:2, fontSize:'12px', textAlign:'center'}}>
              Multiple metrics per Session default Channel Group
            </Typography>

            <Box sx={{ overflowX: "auto" }}>
              <table style={{ width: "100%", fontSize: "12px" }}>
                <thead>
                  <tr style={{ textAlign: "right" }}>
                    <th style={{ textAlign: "left" }}>Channel</th>
                    <th>Sessions</th>
                    <th>Total Users</th>
                    <th>Engagement</th>
                    <th>Reservations</th>
                    <th>Conv %</th>
                  </tr>
                </thead>

                <tbody>
                  {Object.entries(api9_reservations_table).map(([key, item]) => (
                    <tr key={key} style={{ textAlign: "right", borderBottom:'1px solid #dddddd' }}>
                      <td style={{ textAlign: "left" }}>{key}</td>
                      <td>{item.sessions}</td>
                      <td>{item.totalUsers}</td>
                      <td>{item.engagementRate}</td>
                      <td>{item.eventCount}</td>
                      <td>{item.percentage}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}